import * as React from 'react';
import BalanceSheetForFundsCore from '../AfrCore/BalanceSheetForFundsCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import { Afr, generateLocalStateFromEventProperties, getSelectedAfr } from '../../redux/AfrSlice';




const BalanceSheetForFundsCoreWrapper = (props: {
    userRole: string,
    setHasData: (hasData: boolean) => void,
    fundGroup: string,
    noData: string,
    done: string
}) => {
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const fetchState = function () {
        var newState: any = generateLocalStateFromEventProperties(currentAfr, ["workState_balanceSheetComplete", "workState_noBalanceSheet", "reviewState_balanceSheetReviewed"]);
        return newState;
    }
    const [state, setState] = React.useState<boolean>(fetchState());

    const updateState = function (newState: any) {
        setState(newState);
    }

    return (
        <React.Fragment>
            <BalanceSheetForFundsCore
                userRole={props.userRole}
                state={state}
                updateState={updateState}
                setHasData={props.setHasData}
                fundGroup={props.fundGroup}
                noData={props.noData}
                done={props.done}
            />
        </React.Fragment>
    );
}

export default BalanceSheetForFundsCoreWrapper;